export default __webpack_public_path__ + "static/media/Blade's Boots of the Firebringer.8c184103.jpg";